import {
  buildSrc,
  convertToEventDetailUrl,
  sizesForBreakpoints,
  SRCSET_WIDTHS,
  srcSetFromWidths
} from "$lib/utilities";
import { sanitizeSlug } from "$lib/utilities/url-helpers";
import { CHICAGO_TZ } from "./eventDate";

export const formatEventTime = (start, end) => {
  const eventStartDate = new Date(start);
  const eventEndDate = end ? new Date(end) : null;

  const dateStr = eventStartDate.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "2-digit",
    timeZone: CHICAGO_TZ
  });

  let timeStr = `${eventStartDate
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      timeZone: CHICAGO_TZ
    })
    .toLowerCase()
    .replace(" ", "")}`;

  if (eventEndDate) {
    timeStr += ` - ${eventEndDate
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        timeZone: CHICAGO_TZ
      })
      .toLowerCase()
      .replace(" ", "")}`;
  }

  return {
    date: dateStr,
    time: timeStr
  };
};

export const dollarDisplay = (price) => {
  // ticketure 'free' means price == 0
  return !price
    ? "Free"
    : `$${Number.isInteger(price) ? price : Number.parseFloat(price).toFixed(2)}`;
};

export const formatEventPrices = (pricingObj) => {
  let rawPrices = [...new Set(pricingObj.ticketTypes.map((type) => Number(type.price)))];
  return `${dollarDisplay(Math.max(...rawPrices))}`;
};

// Transform event data into display format
export const transformEventToDisplayFormat = ({ event, themedItems = [], showMonth = false }) => {
  if (!event || !event.title || !event.start) {
    return null;
  }
  const eventStartDate = new Date(event.start);
  const monthName = eventStartDate.toLocaleString("default", { month: "long" });
  const dayOfMonth = eventStartDate
    .toLocaleDateString("en-US", {
      day: "2-digit",
      timeZone: CHICAGO_TZ
    })
    .padStart(2, "0");

  const { date, time } = formatEventTime(event.start, event.end);
  const pricing = event?.prices ? formatEventPrices(event.prices) : "";
  const alert =
    event?.alertText || (event?.soldOut ? (pricing === "Free" ? "Event Full" : "Sold Out") : "");

  return {
    headline: showMonth ? `${monthName} ${dayOfMonth}` : dayOfMonth,
    eventTitle: event?.title,
    eventDate: date,
    eventTime: time,
    eventLocation:
      event?.specificLocation?.fields?.locationName || event?.venue?.fields?.name || "The Campus",
    eventPricing: pricing,
    eventAlert: alert,
    image: event?.image
      ? {
          src: buildSrc(event?.image),
          srcset: srcSetFromWidths(event?.image?.fields?.file?.url, SRCSET_WIDTHS),
          sizes: sizesForBreakpoints({
            sm: "50vw",
            md: "33vw",
            lg: "25vw"
          }),
          alt: event?.image?.fields?.description
        }
      : undefined,
    description: event?.summary || event?.description || "",
    theme: event?.theme || "white",
    cta: {
      text: event?.registrationUrl ? "Get tickets" : "Learn more",
      url:
        event.contentType === "program"
          ? sanitizeSlug(event?.obamaorgPath)
          : convertToEventDetailUrl(event?.slug)
    },
    showThemeOnlyOnHover: !themedItems?.some((themedItem) => themedItem.slug === event.slug)
  };
};
